//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: ['item'],
  data: function data() {
    return {
      flag: false
    };
  },
  methods: {
    move: function move() {
      this.flag = true;
    },
    seleave: function seleave() {
      this.flag = false;
    }
  }
};